module.exports = __webpack_public_path__ + "images/directory/featured-hero/zapier.1d6cd361c3c72f0aa00e.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/zapier.jpg
// module id = heVf
// module chunks = 0